import { Box, Paper, Typography, useTheme } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const slickSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: true,
  autoplaySpeed: 3500,
  appendDots: (dots) => <ul style={{ position: "relative", bottom: "-10px" }}>{dots}</ul>,
  customPaging: () => (
    <div
      style={{
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        background: "#ccc"
      }}
    />
  )
};

export const CarouselRules = ({ slides }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "relative",
        ".slick-arrow": {
          zIndex: 2,
          top: "50%",
          transform: "translateY(-50%)",
        },
        ".slick-prev": {
          left: "-15px", 
          [theme.breakpoints.down("sm")]: {
            left: "-10px"
          }
        },
        ".slick-next": {
          right: "-15px",
          [theme.breakpoints.down("sm")]: {
            right: "-10px"
          }
        },
        ".slick-dots": {
          bottom: "-25px"
        }
      }}
    >
      <Slider {...slickSettings}>
        {slides.map((slide, idx) => (
          <Box key={idx} sx={{ padding: 2 }}>
            <Paper
              sx={{
                padding: { xs: 2, md: 3 },
                backgroundColor: "#FFF8E1"
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "1.4rem", color: "#333" }}>
                {slide.title}
              </Typography>
              <Typography variant="body1" sx={{ marginTop: 1, fontSize: "1.2rem", color: "#444" }}>
                {slide.text}
              </Typography>
            </Paper>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};
